// src/belediye/components/mesajlasma/RefMessageCard.js
// FAZ-44: Sohbetteki görev/başvuru mesajı — DÜZ (kutu-içinde-kutu değil), liste
// düzenli (atayan → başlık → açıklama → süre → aciliyet), ayrı renk-ton.
import React from "react";
import { CheckCircleIcon, LinkIcon } from "@heroicons/react/24/outline";

// FAZ-51: görev ikonu TEK sözlükten (kavram değişince her yer değişsin)
import { TaskIcon } from "../icons/appIcons";
// FAZ-55/19: görevin ekleri de kartın içinde — sohbet baloncuğuyla AYNI ızgara.
import { AttachmentGrid } from "./EkGrid";

// FAZ-66: konum bloğu (mini harita + yol tarifi + tam ekran) ORTAK modülde —
// sohbetteki konum mesajı ile görev konumu AYNI bileşeni kullanır.
import KonumBlok from "./KonumBlok";

const gorevSure = (task) => {
  if (!task.due_date) return null;
  const t = new Date(`${task.due_date}T00:00:00`).toLocaleDateString("tr-TR", {
    day: "2-digit",
    month: "long",
  });
  return task.due_time ? `${t} ${String(task.due_time).slice(0, 5)}` : t;
};


export function TaskMessageCard({ task, onOpen, onOpenImage }) {
  const sure = gorevSure(task);
  // FAZ-55/5: sihirbazda seçilen HER ŞEY mesaj kartında da durur — kullanıcı:
  // "görev detayı tümüyle o mesaj yapısında dursun." Şerit özet, mesaj ise
  // görevin kalıcı kaydı: sohbet ilerlese de bu satırlar yerinde kalır.
  const enlem = task.latitude != null ? Number(task.latitude) : null;
  const boylam = task.longitude != null ? Number(task.longitude) : null;
  const konumVar = Number.isFinite(enlem) && Number.isFinite(boylam);
  // Hızlı görevde başlık açıklamanın ilk satırından türetilir → kartta "Başlık"
  // ve "Açıklama" aynı metni iki kez göstermesin. Başlık YALNIZ açıklamadan
  // farklıysa (detaylı görev) gösterilir ("Başlık yalnız detaylıda" kararı).
  const turetilmisBaslik = (task.description || "").trim().split("\n")[0].slice(0, 80);
  const baslikGoster = task.title && task.title !== turetilmisBaslik;
  return (
    <div className="msj-refmsg msj-refmsg--gorev">
      <button type="button" className="msj-refmsg-govde" onClick={onOpen} title="Talep detayına git">
      <div className="msj-refmsg-head">
        <span className="msj-refmsg-tag">
          <TaskIcon /> TALEP
        </span>
        {task.status_display && (
          <span className={`gk-status gk-status--${task.status || "yeni"}`}>{task.status_display}</span>
        )}
      </div>
      <dl className="msj-refmsg-list">
        {task.assigned_by && (
          <>
            <dt>Atayan</dt>
            <dd>{task.assigned_by}</dd>
          </>
        )}
        {baslikGoster && (
          <>
            <dt>Başlık</dt>
            <dd className="msj-refmsg-strong">{task.title}</dd>
          </>
        )}
        {task.description && (
          <>
            <dt>Açıklama</dt>
            <dd>{task.description}</dd>
          </>
        )}
        {sure && (
          <>
            <dt>Süre</dt>
            <dd>{sure}</dd>
          </>
        )}
        {task.unit_name && (
          <>
            <dt>Birim</dt>
            <dd>{task.unit_name}</dd>
          </>
        )}
        {/* FAZ-55/8: görev birden çok mahalleyi kapsayabilir. Liste boşsa eski
            tekil alana düşülür (FAZ-55/8 öncesi görevler). */}
        {(task.neighborhood_names?.length > 0 || task.neighborhood_name) && (
          <>
            <dt>{task.neighborhood_names?.length > 1 ? "Mahalleler" : "Mahalle"}</dt>
            <dd>
              {task.neighborhood_names?.length > 0
                ? task.neighborhood_names.join(", ")
                : task.neighborhood_name}
            </dd>
          </>
        )}
        {task.address && (
          <>
            <dt>Adres</dt>
            <dd>{task.address}</dd>
          </>
        )}
        <dt>Aciliyet</dt>
        <dd>
          <span className={`gk-priority gk-priority--${task.priority || "normal"}`}>
            {task.priority_display || "Normal"}
          </span>
        </dd>
      </dl>
      </button>
      {/* Harita kartın tıklanabilir gövdesinin DIŞINDA — kendi düğmeleri var. */}
      {konumVar && <KonumBlok enlem={enlem} boylam={boylam} />}
      {/* FAZ-55/19 — GÖREVİN EKLERİ. Kullanıcı: "harita nasıl gidiyorsa fotoğraf
          da gitsin, haritanın yapısını değiştirmeden altına aynı mantıkta; çok
          fotoğraf az fotoğraf ya da belge varsa gönder." Bu yüzden ek bloğu tam
          da haritanın hemen ALTINDA ve haritayla aynı gerekçeyle kartın
          tıklanabilir gövdesinin DIŞINDA duruyor: resme tıklamak büyütür, karta
          tıklamak göreve gider — ikisi çakışmasın. Izgara/lightbox kuralı ortak
          modülden (EkGrid) gelir; sohbetteki üç-resim düzeniyle birebir aynı. */}
      {task.attachments?.length > 0 && (
        <div className="msj-refmsg-ekler">
          <AttachmentGrid atts={task.attachments} onOpenImage={onOpenImage} />
        </div>
      )}
      <button type="button" className="msj-refmsg-foot" onClick={onOpen} title="Talep detayına git">
        <span className="msj-refmsg-iletildi">
          <CheckCircleIcon /> İletildi
        </span>
        <span className="msj-refmsg-go">Detay →</span>
      </button>
    </div>
  );
}

export function AppMessageCard({ app, canOpen, onOpen }) {
  return (
    <button
      type="button"
      className="msj-refmsg msj-refmsg--basvuru"
      disabled={!canOpen}
      onClick={canOpen ? onOpen : undefined}
      title={canOpen ? "Başvuruya git" : undefined}
    >
      <div className="msj-refmsg-head">
        <span className="msj-refmsg-tag">
          <LinkIcon /> BAŞVURU
        </span>
        {app.status_display && <span className="msj-refmsg-status">{app.status_display}</span>}
      </div>
      <dl className="msj-refmsg-list">
        <dt>No</dt>
        <dd className="msj-refmsg-strong">#{app.tracking_number}</dd>
        {app.subject && (
          <>
            <dt>Konu</dt>
            <dd>{app.subject}</dd>
          </>
        )}
      </dl>
      <div className="msj-refmsg-foot">
        <span className="msj-refmsg-iletildi">
          <CheckCircleIcon /> İletildi
        </span>
        {canOpen && <span className="msj-refmsg-go">Detay →</span>}
      </div>
    </button>
  );
}
